<ul class="alert-list">
  <li *ngFor="let alert of (alerts$ | async)"
      [ngClass]="{'resolved': alert.status === 'resolved', 'firing': alert.status === 'firing'}">
    <span class="alert-title">
      <mat-icon class="alert-icon"
        [ngClass]="{'critical': alert.severity === 'critical', 'warning': alert.severity === 'warning'}">
        {{ alert.severity === 'critical' ? 'error' : (alert.severity === 'warning' ? 'report_problem' : 'info') }}
      </mat-icon>
      {{ alert.status == 'resolved' ? "(RESOLVED) " : ''}}{{ alert.labels.system ? "(" + alert.labels.system + ") " : ''}}{{ alert.labels.systemName ? alert.labels.systemName + ": " : ''}}{{ alert.summary || alert.type || 'Alert' }}
    </span>
    <span class="alert-description">{{ alert.description }}</span>
    <span class="alert-meta">
      <span *ngIf="alert.timestamp">{{ alert.timestamp ? (alert.timestamp * 1000 | date: 'dd:MM:yyyy HH:mm') : 'N/A' }}</span>
      <span *ngIf="alert.startsAt">Start at: {{ alert.startsAt ? (alert.startsAt.toDate() | date: 'dd.MM.yyyy HH:mm') : 'N/A' }}</span>
      <span>- Status: {{ (alert.status | titlecase) || 'N/A' }}</span>
      <span>- Ended at: {{ alert.endsAt ? (alert.endsAt.toDate() | date: 'dd.MM.yyyy HH:mm') : 'N/A' }}</span>
      <span>- Severity: {{ (alert.severity | titlecase) || 'N/A' }}</span>
      <span>
        Message Received:
        <ng-container *ngIf="alert.unix && alert.unix > 0; else noUnix">
          {{ alert.unix * 1000 | date: 'dd:MM:yyyy HH:mm' }}
        </ng-container>
        <ng-template #noUnix>N/A</ng-template>
      </span>
    </span>
    <ul class="alert-labels" *ngIf="!isMobile">
      <li *ngFor="let label of alert.labels | keyvalue">
        <strong>{{ label.key }}:</strong> {{ label.value }}
      </li>
    </ul>
    <button mat-icon-button color="warn" aria-label="Delete alert"
      (click)="$event.stopPropagation(); deleteAlert(alert)">
      <mat-icon>delete</mat-icon>
    </button>
  </li>
</ul>